"use client";

import Image from "next/image";
import { Button } from "@/ui";

export interface CTAOverlayImageProps {
  title?: string;
  subtitle?: string;
  imageSrc?: string;
  imageAlt?: string;
  primaryLabel?: string;
  secondaryLabel?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

export default function CTAOverlayImage({
  title = "Book your table today",
  subtitle = "Join us for an unforgettable dining experience.",
  imageSrc = "https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.1.0",
  imageAlt = "Restaurant ambiance",
  primaryLabel = "Reserve Now",
  secondaryLabel = "View Menu",
  onPrimaryClick,
  onSecondaryClick,
}: CTAOverlayImageProps) {
  return (
    <section className="max-w-7xl mx-auto px-6">
      <div className="relative h-72 md:h-96 overflow-hidden rounded-3xl">
        <Image
          src={imageSrc}
          alt={imageAlt}
          fill
          className="object-cover"
          unoptimized
        />
        <div
          className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent"
          aria-hidden="true"
        />
        <div className="absolute inset-0 flex items-center">
          <div className="px-8 md:px-12 max-w-2xl">
            <h3 className="text-3xl md:text-5xl font-bold text-white mb-3">
              {title}
            </h3>
            <p className="text-white/85 text-lg md:text-xl mb-6">{subtitle}</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                type="button"
                variant="secondary"
                size="lg"
                onClick={onPrimaryClick}
                className="rounded-full bg-white text-black"
              >
                {primaryLabel}
              </Button>
              <Button
                type="button"
                variant="ghost"
                size="lg"
                onClick={onSecondaryClick}
                className="rounded-full text-white border-white/60"
              >
                {secondaryLabel}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
